<main #sxkm class="sxkm">
    <app-navbar></app-navbar>
    <div class="tabs">
        <app-tabs-panel></app-tabs-panel>
        <div class="tab-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</main>
